<template>
  <div>
    <div class="py-2 ml-4 font-Poppins text-dbs-light-black">
      <span><strong>Total per day</strong></span>
    </div>
    <VueApexCharts
      :options="chartDataOptions"
      :series="props.seriesData"
      height="300"
      width="1030"
    ></VueApexCharts>
  </div>
</template>

<script setup>
import { computed, toRaw, watch } from "vue";
import VueApexCharts from "vue3-apexcharts";

const emit = defineEmits(["no-data"]);

watch(
  () => props.seriesData,
  (newVal) => {
    if (!newVal.length) {
      emit("no-data");
    }
  },
  { immediate: true },
);

const props = defineProps({
  seriesData: {
    type: Array,
    required: false,
    default: () => [],
  },
  // categories: {
  //   type: Array,
  //   required: false,
  // },
});

const avgData = computed(() => {
  if (props.seriesData.length === 0 || !props.seriesData[0].data) {
    return 0;
  }

  const numbers = toRaw(props.seriesData[0].data)
    .filter((number) => number.y)
    .map((number) => number.y);
  const avg =
    numbers.reduce((acc, cur) => acc + cur, 0) /
    props.seriesData[0].data.length;

  return avg;
});

const chartDataOptions = computed(() => {
  const options = {
    chart: {
      height: "350",
      type: "area",
      toolbar: {
        show: true,
      },
      data: "dates",
    },
    noData: {
      text: "No data",
      align: "center",
      verticalAlign: "middle",
      offsetX: 0,
      offsetY: 0,
      style: {
        color: undefined,
        fontSize: "14px",
        fontFamily: undefined,
      },
    },
    xaxis: {
      type: "datetime",
      labels: {
        show: true,
        hideOverlappingLabels: true,
      },
    },
    stroke: {
      curve: "smooth",
      width: 2.5,
    },
    colors: [
      "#6DAFB9",
      "#0c1e36",
      "#B99D64",
      "#45676D",
      "#372D6C",
      "#6455B6",
      "#4AB0A6",
      "#AB4A46",
      "#F67570",
      "#F8B14B",
      "#DCE1DE",
      "#393B3C",
      "#BA7A75",
    ],
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    markers: {
      size: 0,
    },
    yaxis: {
      labels: {
        show: true,
        formatter: function (val) {
          return val + " kWh";
        },
      },
    },
    annotations: {
      yaxis: [
        {
          y: avgData.value,
          y2: avgData.value - 10,
          opacity: 1,
          fillColor: "#2B978D",
          borderColor: "#2B978D",
          label: {
            textAnchor: "start",
            position: "left",
            borderColor: "#2B978D",
            borderWidth: 5,
            style: {
              color: "#fff",
              width: "2px",
              background: "#2B978D",
            },
            text: `Average Consumption Per Day (${avgData.value.toFixed(
              2,
            )} kWh)`,
          },
        },
      ],
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: {
            width: 900,
          },
          legend: {
            show: true,
          },
        },
      },
      {
        breakpoint: 767,
        options: {
          chart: {
            width: 1030,
          },
          legend: {
            show: true,
          },
        },
      },
      {
        breakpoint: 768,
        options: {
          chart: {
            width: 590,
          },
          legend: {
            show: true,
          },
        },
      },
      {
        breakpoint: 1040,
        options: {
          chart: {
            width: 700,
          },
          legend: {
            show: true,
          },
        },
      },
    ],

    tooltip: {
      shared: true,
      intersect: false,
    },
  };

  return options;
});
</script>
